import { render } from "./Respuesta.vue?vue&type=template&id=ca3f0faa"
import script from "./Respuesta.vue?vue&type=script&lang=js"
export * from "./Respuesta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__